import { api } from "core/axios/axios";

export async function invokeBedrockAgent(body: { inputText: string }) {
    return api.post(
        "agent/invokeBedrockAgent",
        body
    );
}